/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_ConsultInputs */

const en_platform_preview_consult = /** @type {(inputs: Platform_Preview_ConsultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online consultation`)
};

const pl_platform_preview_consult = /** @type {(inputs: Platform_Preview_ConsultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultacja online`)
};

/**
* | output |
* | --- |
* | "Online consultation" |
*
* @param {Platform_Preview_ConsultInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_consult = /** @type {((inputs?: Platform_Preview_ConsultInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_ConsultInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_consult(inputs)
	return en_platform_preview_consult(inputs)
});